
const initAlgoliaSearch = async () => {
    const { default: algoliasearch } = await import('algoliasearch/lite');
    const { autocomplete, getAlgoliaResults } = await import('@algolia/autocomplete-js');
    const {decode} = await import('html-entities');
    const searchClient = algoliasearch(
        `${app.algolia_id}`,
        `${app.algolia_secret }`
    );

    autocomplete({
        container: '#search-container',
        placeholder: 'Rechercher des informations',
        debug: true,
        detachedMediaQuery: '',
        translations: {
            detachedCancelButtonText: 'Annuler'
        },
        getSources({ query }) {
            return [
                {
                    sourceId: 'page_contents',
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: `${app.scout_prefix}page_contents`,
                                    query,
                                },
                            ],
                        });
                    },
                    templates: {
                        item({ item, html}) {
                            return html`<div class="h-100">
                                <a class="d-flex align-items-center h-100 w-1OO" href='${item.url}'>
                                    ${decode(item.title || item.cover_title)}
                                </a>
                            </div>`;
                        },
                    }
                },
                {
                    sourceId: 'pages',
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: `${app.scout_prefix}pages`,
                                    query,
                                },
                            ],
                        });
                    },
                    templates: {
                        item({ item, html}) {
                            return html`<div class="h-100">
                                <a class="d-flex align-items-center h-100 w-1OO" href='${item.url}'>
                                    ${decode(item.nav_title)}
                                </a>
                            </div>`;
                        },
                    }
                },
                {
                    sourceId: 'news_articles',
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: `${app.scout_prefix}news_articles`,
                                    query,
                                },
                            ],
                        });
                    },
                    templates: {
                        item({ item, html}) {
                            return html`<div class="h-100">
                                <a class="d-flex align-items-center h-100 w-1OO" href='${item.url}'>
                                    ${decode(item.title)}
                                </a>
                            </div>`;
                        },
                    }
                },
                {
                    sourceId: 'achievements',
                    getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: `${app.scout_prefix}achievements`,
                                    query,
                                },
                            ],
                        });
                    },
                    templates: {
                        item({ item, html }) {
                            return html`<div class="h-100">
                                <a class="d-flex align-items-center h-100 w-1OO" href='${item.url}'>
                                    ${decode(item.title)}
                                </a>
                            </div>`;
                        },
                    }
                },
            ];
        },
        renderNoResults({ render, html }, root) {
            render(html`<div class='m-3'>Aucun résultat</div>`, root);
        },
    });

    document.addEventListener('keydown', () => {
        if (document.querySelector('.aa-DetachedOverlay') && (event.key === 'Enter' || event.keyCode === 13)) {
            event.preventDefault();
        }
    })
}

export default class Algolia {
    static init() {
        initAlgoliaSearch();
    }
}
